import { Input, Tabs } from 'antd';
import { FormattedMessage } from 'react-intl';

import type { AppVersionContents } from '@/services/app-version-updates';

import type { I18nLocale } from '../types';
import { I18N_LOCALES } from '../types';

export type I18nContentTabsProps = {
    value: AppVersionContents;
    disabled?: boolean;
    activeKey: I18nLocale;
    onActiveKeyChange: (key: I18nLocale) => void;
    onChange: (locale: I18nLocale, text: string) => void;
};

const localeTabLabel = (locale: I18nLocale) => {
    if (locale === 'zh' || locale === 'en') {
        return <FormattedMessage id={`appVersionUpdates.i18n.${locale}.required`} />;
    }
    return <FormattedMessage id={`appVersionUpdates.i18n.${locale}`} />;
};

const I18nContentTabs: React.FC<I18nContentTabsProps> = ({
    value,
    disabled,
    activeKey,
    onActiveKeyChange,
    onChange,
}) => {
    const items = I18N_LOCALES.map((locale) => ({
        key: locale,
        label: localeTabLabel(locale),
        children: (
            <Input.TextArea
                rows={4}
                disabled={disabled}
                value={value[locale] ?? ''}
                placeholder={`${locale.toUpperCase()}...`}
                onChange={(event) => onChange(locale, event.target.value)}
            />
        ),
    }));

    return (
        <div className="i18n-panel">
            <Tabs
                activeKey={activeKey}
                items={items}
                onChange={(key) => onActiveKeyChange(key as I18nLocale)}
            />
        </div>
    );
};

export default I18nContentTabs;
